// third-party
import { FormattedMessage } from 'react-intl';

// assets
import MedicineBoxOutlined from '@ant-design/icons/MedicineBoxOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalPharmacyOutlinedIcon from '@mui/icons-material/LocalPharmacyOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
// type

// icons
const icons = { MedicineBoxOutlined };

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const catalog = {
  id: 'catalog',
  title: <FormattedMessage id="Catalog" />,
  icon: icons.MedicineBoxOutlined,
  type: 'group',
  children: [
    {
      id: 'medicine-list',
      key:'medicine-list',
      title: <FormattedMessage id="Medicines" />,
      type: 'item',
      url: '/medicine-list',
      icon: LocalPharmacyOutlinedIcon
    },
    {
      id: 'salt-interactions',
      key: 'salt-interactions',
      title: <FormattedMessage id="Salt Interactions" />,
      type: 'item',
      url: '/salt-interactions',
      icon: SyncAltOutlinedIcon,
      visible: (roles = []) => roles.some((role) => String(role).toLowerCase() === 'superuser')
    },
    {
      id: 'non-medicine-list',
      key:'non-medicine-list',
      title: <FormattedMessage id="Non Medicines" />,
      type: 'item',
      url: '/non-medicine-list',
      icon: Inventory2OutlinedIcon
    }
  ]
};

export default catalog;
